import type { IProcessActivityReadSection } from '@common/interfaces/processActivityReadSection';
import type { OsaReferralReadData } from '@common/validation/customControls/osas/osasReferralSchemas/osasReferralReadSchema';
import { getProcessActivityReadSectionItem } from '@common/utils/processActivityReadUtil';
import { FormGroupRowAndColsWithFormParagraph } from '@frontend/components/fields/FormGroupRowAndColsWithFormParagraph';
import { setProfessionalSummaryReadComponents } from '@frontend/components/pages/episodeCategory/customControls/processActivityProfessionalSummaryData/utils/setProfessionalSummaryReadComponents';
import { addAssetsComponent } from '@frontend/formEngine/readForm/readFormComponents';
import { ProcessActivityMedicationsRead } from '../../../../processActivityMedications/ProcessActivityMedicationsRead';

export function getOsasReferralReadComponents(
    readSections: IProcessActivityReadSection<string, string, string>[],
    processActivityId: string
) {
    const map = new Map();

    const patientUsesMedicationItem = getProcessActivityReadSectionItem<OsaReferralReadData>()(
        readSections,
        'patientUsesMedication'
    );

    if ((patientUsesMedicationItem?.value as unknown as string) === 'Ja') {
        map.set(
            patientUsesMedicationItem?.key,
            <ProcessActivityMedicationsRead
                patientUsesMedication={patientUsesMedicationItem?.value ?? null}
                processActivityId={processActivityId}
                shouldRemoveSectionTitle={true}
            />
        );
    }

    const bmiItem = getProcessActivityReadSectionItem<OsaReferralReadData>()(readSections, 'weight_length_bmi');

    if (bmiItem?.value) {
        map.set(
            bmiItem.key,
            <FormGroupRowAndColsWithFormParagraph
                label={bmiItem.label}
                values={bmiItem.value}
            />
        );
    }
    const alcoholConsumptionItem = getProcessActivityReadSectionItem<OsaReferralReadData>()(
        readSections,
        'alcoholConsumption'
    );

    if (alcoholConsumptionItem?.value) {
        map.set(
            alcoholConsumptionItem.key,
            <FormGroupRowAndColsWithFormParagraph
                label={alcoholConsumptionItem.label}
                values={alcoholConsumptionItem.value}
            />
        );
    }

    const smokingItem = getProcessActivityReadSectionItem<OsaReferralReadData>()(readSections, 'years_packs');

    if (smokingItem?.value) {
        map.set(
            smokingItem.key,
            <FormGroupRowAndColsWithFormParagraph
                label={smokingItem.label}
                values={smokingItem.value}
            />
        );
    }
    addAssetsComponent(readSections, map);
    setProfessionalSummaryReadComponents({ map, processActivityId, readSections });

    return map;
}
